import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Building2 } from 'lucide-react';
import api from '../lib/api';
import { Button } from '../components/ui/button';

const TYPE = { individual: 'Individual', sole_trader: 'Sole trader', company: 'Company', trust: 'Trust', partnership: 'Partnership', smsf: 'Self-managed super fund' };

export default function MyEntities() {
  const [rows, setRows] = useState(null);
  const load = () => api.get('/api/portal/my-entities').then((r) => setRows(r.data.entities)).catch(() => toast.error('We couldn’t load your entities. Please try again.'));
  useEffect(() => { load(); }, []);
  const switchTo = async (id) => {
    try {
      await api.put('/api/portal-access/my/current', { client_id: id });
      sessionStorage.setItem('kv_entity', id);
      window.dispatchEvent(new Event('kv-entity-changed'));
      toast.success('Switched entity');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not switch'); }
  };
  return (
    <div className="p-4 sm:p-6 lg:p-10 space-y-6" data-testid="my-entities-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-headings font-bold">My entities</h1>
        <p className="text-sm text-muted-foreground mt-2">The people and businesses you can see in this portal. Ask your accountant if one is missing.</p>
      </div>
      {!rows ? <p className="text-sm text-muted-foreground">Loading…</p> : (
        <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {rows.map((e) => (
            <li key={e.id} className="rounded-xl border border-border bg-card p-4 space-y-2" data-testid={`entity-card-${e.id}`}>
              <p className="flex items-center gap-2 font-medium"><Building2 className="w-4 h-4 text-primary" aria-hidden="true" />{e.name}</p>
              <p className="text-xs text-muted-foreground">{TYPE[e.entity_type] || e.entity_type} · {e.outstanding ? `${e.outstanding} item(s) to do` : 'Nothing outstanding'}</p>
              {e.services?.length > 0 && <p className="text-xs" data-testid={`entity-services-${e.id}`}>Services: {e.services.join(', ')}</p>}
              {e.current ? <span className="text-xs font-semibold text-primary">You’re viewing this entity</span>
                : <Button size="sm" variant="outline" onClick={() => switchTo(e.id)} data-testid={`entity-switch-${e.id}`}>View this entity</Button>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
